import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    modal: {
        isModalOpen: false,
        sectionOpen: null,
        isAllFilters: false
    }

}
const searchbarSlice = createSlice({
    name: 'searchbar',
    initialState: initialState,
    reducers: {
        setIsModalOpen: (state, action) => { state.modal.isModalOpen = action.payload }, // true o false
        setSectionOpen: (state, action) => { state.modal.sectionOpen = action.payload }, // "where", "who", "when", null
        setIsAllFilters: (state, action) => { state.modal.isAllFilters = action.payload }, // true o false
    }
})

export const { setIsModalOpen, setSectionOpen, setIsAllFilters, setIsPoolOpen, setWhichPage, setIsAllFiltersOpen } = searchbarSlice.actions;
export default searchbarSlice.reducer;